/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import axios, { AxiosRequestConfig } from 'axios';
import { API_URL } from '../constants';
import type { Doctor } from '../types/ninox.types';
import type { AxiosReturn } from '../types/return.types';
import { getAPIToken } from '../utils';

function getAxiosConfig(): AxiosRequestConfig {
  return {
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getAPIToken()}`,
    },
  };
}

export class DoctorService {
  static async createDoctor(doctor: Doctor): Promise<AxiosReturn> {
    return new Promise((resolve) => {
      axios
        .post('/doctor', doctor, getAxiosConfig())
        .then((response) => {
          resolve({ error: false, message: 'Success', data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: 'Error', data: error });
        });
    });
  }

  static async getAllDoctors(): Promise<AxiosReturn> {
    return new Promise((resolve) => {
      axios
        .get('/doctor', getAxiosConfig())
        .then((response) => {
          resolve({ error: false, message: 'Success', data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: 'Error', data: error });
        });
    });
  }

  static async getDoctor(id: number): Promise<AxiosReturn> {
    return new Promise((resolve) => {
      axios
        .get(`/doctor/${id}`, getAxiosConfig())
        .then((response) => {
          resolve({ error: false, message: 'Success', data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: 'Error', data: error });
        });
    });
  }

  static async getAppointmentStats(): Promise<AxiosReturn> {
    return new Promise((resolve) => {
      axios
        .get('/doctor/appointment-stats', getAxiosConfig())
        .then((response) => {
          resolve({ error: false, message: 'Success', data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: 'Error', data: error });
        });
    });
  }

  static async getFreeAppointments(doctorId: number, url: string): Promise<AxiosReturn> {
    return new Promise((resolve) => {
      axios
        .get(`/doctor/${doctorId}/free-appointments/all`, getAxiosConfig())
        .then((response) => {
          resolve({ error: false, message: 'Success', data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: 'Error', data: error });
        });
    });
  }
}
